(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('.jv-atc-form') : null;
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '\u2026';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(form.querySelector('[name="id"]').value), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.textContent = '\u2713 Im Warenkorb';
        return fetch('/?sections=cart-icon-bubble')
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && sections['cart-icon-bubble']) {
              var parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
              var inner = parsed.querySelector('.shopify-section');
              if (inner) bubble.innerHTML = inner.innerHTML;
            }
          });
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2200);
      });
  });
})();
